module.exports = __webpack_public_path__ + "static/media/my-account-transactions.7c73f5ea.svg";